export default {
  methods: {
    // processDateRestrictions(cutoffs) {
    //   let finalUnavailableDates = cutoffs.un_available;
    //   let finalAvailableDates = [];
    //   let finalCutoffs = [];
    //   const currentTimeStamp = this.$dayjs.utc(cutoffs.currentTime).tz("America/Winnipeg");
    //
    //   if (cutoffs.available.length > 0) {
    //     for (let availableDateItem of cutoffs.available) {
    //       const dates = availableDateItem.date.split(",");
    //       const overrideCutoffTime = availableDateItem.cutoff_time;
    //       const overrideCutoffEffect = availableDateItem.cutoff_effect;
    //
    //       for (let date of dates) {
    //         const availableDate = this.$dayjs(date.trim()).format("YYYY-MM-DD");
    //
    //         // Calculate the cutoff timestamp for this specific available date
    //         let cutOffTimeStamp = this.$dayjs.tz(date.trim(), "America/Winnipeg")
    //           .subtract(overrideCutoffEffect, "d")
    //           .add(overrideCutoffTime.split(":")[0], "h")
    //           .add(overrideCutoffTime.split(":")[1], "m");
    //
    //         // Check if the cutoff timestamp has passed the current time
    //         if (cutOffTimeStamp.isBefore(currentTimeStamp)) {
    //           // If cutoff has passed, add date to unavailable list
    //           if (!finalUnavailableDates.includes(availableDate)) {
    //             finalUnavailableDates.push(availableDate);
    //           }
    //         } else {
    //           // If cutoff hasn't passed, add date to available list
    //           finalAvailableDates.push(availableDate);
    //         }
    //
    //         // Add each date and its calculated cutoff timestamp to finalCutoffs
    //         finalCutoffs.push({
    //           deliveryDate: availableDate,
    //           cutoffEffect: cutOffTimeStamp.format()
    //         });
    //       }
    //     }
    //   }
    //
    //   // Process unavailability based on default cutoff times for upcoming 4 days
    //   for (let i = 0; i < 4; i++) {
    //     let processDate = this.$dayjs(cutoffs.currentTime).tz("America/Winnipeg").add(i, "d");
    //     let cutoff = cutoffs.cutoff_time
    //       .filter((df) => +df.day === processDate.day())
    //       .map((ct) => JSON.parse(JSON.stringify(ct)));
    //
    //     if (cutoff[0]) {
    //       let cutOffTimeStamp = processDate
    //         .subtract(parseInt(cutoff[0].cutoff_effect), "d")
    //         .startOf("d")
    //         .add(cutoff[0].cutoff_time.split(":")[0], "h")
    //         .add(cutoff[0].cutoff_time.split(":")[1], "m");
    //
    //       const processDateString = processDate.format("YYYY-MM-DD");
    //       if (cutOffTimeStamp.isBefore(currentTimeStamp)) {
    //         if (!finalUnavailableDates.includes(processDateString)) {
    //           finalUnavailableDates.push(processDateString);
    //         }
    //       }
    //
    //       finalCutoffs.push({
    //         deliveryDate: processDateString,
    //         cutoffEffect: cutOffTimeStamp.format() // Store cutoffEffect as a timestamp
    //       });
    //     }
    //   }
    //   return {
    //     finalAvailableDates,
    //     finalUnavailableDates,
    //     finalCutoffs
    //   };
    // },
    processDateRestrictions(cutoffs) {
      let finalUnavailableDates = cutoffs.un_available;
      let finalAvailableDates = [];
      let finalCutoffs = [];

      // Convert current time from UTC to Winnipeg timezone
      const currentTimeStamp = this.$dayjs.utc(cutoffs.currentTime).tz("America/Winnipeg");

      if (cutoffs.available.length > 0) {
        for (let availableDateItem of cutoffs.available) {
          const dates = availableDateItem.date.split(",");
          const overrideCutoffTime = availableDateItem.cutoff_time;
          const overrideCutoffEffect = availableDateItem.cutoff_effect;

          for (let date of dates) {
            const availableDate = this.$dayjs.tz(date.trim(), "America/Winnipeg").format("YYYY-MM-DD");

            // Calculate the cutoff timestamp for this available date in Winnipeg time
            let cutOffTimeStamp = this.$dayjs.tz(availableDate, "America/Winnipeg")
              .subtract(overrideCutoffEffect, "day") // Apply cutoff effect (subtract days)
              .hour(overrideCutoffTime.split(":")[0]) // Set cutoff hour
              .minute(overrideCutoffTime.split(":")[1]) // Set cutoff minute
              .second(0)
              .millisecond(0);

            // Check if the cutoff timestamp has passed
            if (cutOffTimeStamp.isBefore(currentTimeStamp)) {
              if (!finalUnavailableDates.includes(availableDate)) {
                finalUnavailableDates.push(availableDate);
              }
            } else {
              finalAvailableDates.push(availableDate);
            }

            // Store the cutoff time for reference
            finalCutoffs.push({
              deliveryDate: availableDate,
              cutoffEffect: cutOffTimeStamp.format() // Store cutoff time in correct format
            });
          }
        }
      }

      // Process unavailability based on default cutoff times for the next 4 days
      for (let i = 0; i < 4; i++) {
        let processDate = this.$dayjs.utc(cutoffs.currentTime).tz("America/Winnipeg").add(i, "day");
        let cutoff = cutoffs.cutoff_time
          .filter((df) => +df.day === processDate.day())
          .map((ct) => JSON.parse(JSON.stringify(ct)));

        if (cutoff[0]) {
          let cutOffTimeStamp = processDate
            .subtract(parseInt(cutoff[0].cutoff_effect), "day")
            .startOf("day")
            .hour(cutoff[0].cutoff_time.split(":")[0])
            .minute(cutoff[0].cutoff_time.split(":")[1]);

          const processDateString = processDate.format("YYYY-MM-DD");
          if (cutOffTimeStamp.isBefore(currentTimeStamp)) {
            if (!finalUnavailableDates.includes(processDateString)) {
              finalUnavailableDates.push(processDateString);
            }
          }

          finalCutoffs.push({
            deliveryDate: processDateString,
            cutoffEffect: cutOffTimeStamp.format() // Store cutoff as timestamp
          });
        }
      }

      return {
        finalAvailableDates,
        finalUnavailableDates,
        finalCutoffs
      };
    },
    // checkCutoffStatus(cutoffs, deliveryDates) {
    //   // Parse the current time in America/Winnipeg timezone
    //   const currentTimeStamp = this.$dayjs(cutoffs.currentTime).tz("America/Winnipeg");
    //   let cutoffStatuses = [];
    //
    //   for (let deliveryDate of deliveryDates) {
    //     const formattedDeliveryDate = this.$dayjs(deliveryDate, "YYYY-MM-DD").startOf("day").tz("America/Winnipeg", true);
    //     let cutOffTimeStamp;
    //     let cutoffSource = ""; // To indicate if using override or default cutoff
    //
    //     // Step 1: Check for an override cutoff for the specific delivery date
    //     const overrideCutoff = cutoffs.available.find((item) => item.date === formattedDeliveryDate.format("YYYY-MM-DD"));
    //
    //     if (overrideCutoff) {
    //       // Use the override cutoff time and effect
    //       cutOffTimeStamp = formattedDeliveryDate
    //         .subtract(overrideCutoff.cutoff_effect, "d")
    //         .add(overrideCutoff.cutoff_time.split(":")[0], "h")
    //         .add(overrideCutoff.cutoff_time.split(":")[1], "m");
    //       cutoffSource = "Override Cutoff"; // Label as override cutoff
    //     } else {
    //       // Step 2: No override, so use the default cutoff based on the day of the week
    //       const dayOfWeek = formattedDeliveryDate.day();
    //       const defaultCutoff = cutoffs.cutoff_time.find((df) => +df.day === dayOfWeek);
    //
    //       if (defaultCutoff) {
    //         cutOffTimeStamp = formattedDeliveryDate
    //           .subtract(defaultCutoff.cutoff_effect, "d")
    //           .add(defaultCutoff.cutoff_time.split(":")[0], "h")
    //           .add(defaultCutoff.cutoff_time.split(":")[1], "m");
    //         cutoffSource = "Default Cutoff"; // Label as default cutoff
    //       } else {
    //         // If no default cutoff is available for the day, add a message and continue
    //         cutoffStatuses.push({
    //           deliveryDate: formattedDeliveryDate.format("YYYY-MM-DD"),
    //           status: "No cutoff available for this date"
    //         });
    //         // console.log(`Delivery Date: ${formattedDeliveryDate} - No specific or default cutoff found.`);
    //         continue;
    //       }
    //     }
    //
    //     // Log details to debug which cutoff is being used
    //     // console.log(`Delivery Date: ${formattedDeliveryDate}`);
    //     // console.log(`Cutoff Source: ${cutoffSource}`);
    //     // console.log(`Cutoff Time (America/Winnipeg): ${cutOffTimeStamp.format()}`);
    //     // console.log(`Current Time (America/Winnipeg): ${currentTimeStamp.format()}`);
    //
    //     // Calculate the time difference
    //     const timeRemainingInMinutes = cutOffTimeStamp.diff(currentTimeStamp, "minutes");
    //     const daysRemaining = Math.floor(timeRemainingInMinutes / (60 * 24));
    //     const hoursRemaining = Math.floor((timeRemainingInMinutes % (60 * 24)) / 60);
    //     const minutesRemaining = timeRemainingInMinutes % 60;
    //
    //     // Log the calculated time remaining for debugging
    //     // console.log(`Calculated Time Remaining - Hours: ${hoursRemaining}, Minutes: ${minutesRemaining}`);
    //
    //     // Check if the current time is before or after the cutoff time
    //     if (cutOffTimeStamp.isBefore(currentTimeStamp)) {
    //       cutoffStatuses.push({
    //         deliveryDate: formattedDeliveryDate.format("YYYY-MM-DD"),
    //         status: "Cutoff has already passed"
    //       });
    //     } else {
    //       cutoffStatuses.push({
    //         deliveryDate: formattedDeliveryDate.format("YYYY-MM-DD"),
    //         status: {
    //           hoursRemaining,
    //           minutesRemaining,
    //           daysRemaining
    //         }
    //       });
    //     }
    //   }
    //   return cutoffStatuses;
    // },
    checkCutoffStatus(cutoffs, deliveryDates) {
      // Convert current time from UTC to America/Winnipeg timezone
      const currentTimeStamp = this.$dayjs.utc(cutoffs.currentTime).tz("America/Winnipeg");
      let cutoffStatuses = [];

      for (let deliveryDate of deliveryDates) {
        // Ensure deliveryDate is properly interpreted in America/Winnipeg timezone
        const formattedDeliveryDate = this.$dayjs.tz(deliveryDate, "America/Winnipeg").startOf("day");

        let cutOffTimeStamp;
        let cutoffSource = "";

        // Step 1: Check for an override cutoff for the specific delivery date
        const overrideCutoff = cutoffs.available.find((item) => item.date === formattedDeliveryDate.format("YYYY-MM-DD"));

        if (overrideCutoff) {
          // Use the override cutoff time and effect
          cutOffTimeStamp = formattedDeliveryDate
            .subtract(overrideCutoff.cutoff_effect, "day")
            .hour(overrideCutoff.cutoff_time.split(":")[0])
            .minute(overrideCutoff.cutoff_time.split(":")[1])
            .second(0)
            .millisecond(0);

          cutoffSource = "Override Cutoff";
        } else {
          // Step 2: Use the default cutoff based on the day of the week
          const dayOfWeek = formattedDeliveryDate.day();
          const defaultCutoff = cutoffs.cutoff_time.find((df) => +df.day === dayOfWeek);

          if (defaultCutoff) {
            cutOffTimeStamp = formattedDeliveryDate
              .subtract(defaultCutoff.cutoff_effect, "day")
              .hour(defaultCutoff.cutoff_time.split(":")[0])
              .minute(defaultCutoff.cutoff_time.split(":")[1])
              .second(0)
              .millisecond(0);

            cutoffSource = "Default Cutoff";
          } else {
            // No cutoff available for this day
            cutoffStatuses.push({
              deliveryDate: formattedDeliveryDate.format("YYYY-MM-DD"),
              status: "No cutoff available for this date"
            });
            continue;
          }
        }

        // Calculate time remaining
        const timeRemainingInMinutes = cutOffTimeStamp.diff(currentTimeStamp, "minutes");
        const daysRemaining = Math.floor(timeRemainingInMinutes / (60 * 24));
        const hoursRemaining = Math.floor((timeRemainingInMinutes % (60 * 24)) / 60);
        const minutesRemaining = timeRemainingInMinutes % 60;

        // Check if the cutoff has already passed
        if (cutOffTimeStamp.isBefore(currentTimeStamp)) {
          cutoffStatuses.push({
            deliveryDate: formattedDeliveryDate.format("YYYY-MM-DD"),
            status: "Cutoff has already passed"
          });
        } else {
          cutoffStatuses.push({
            deliveryDate: formattedDeliveryDate.format("YYYY-MM-DD"),
            status: {
              hoursRemaining,
              minutesRemaining,
              daysRemaining
            }
          });
        }
      }
      return cutoffStatuses;
    },
    findNextAvailableDate(date, finalCutOffList) {
      // Convert input date to Winnipeg timezone
      let nextAvailableDate = this.$dayjs(date).tz("America/Winnipeg");
      let foundNextAvailableDate = false;

      do {
        const selectedDate = nextAvailableDate.format("YYYY-MM-DD");

        // Check against available list first
        if (finalCutOffList.finalAvailableDates.includes(selectedDate)) {
          foundNextAvailableDate = true;

          // Then check if date is a closed day or unavailable
        } else if (
          finalCutOffList.finalCloseDays.includes(nextAvailableDate.day()) ||
          finalCutOffList.finalUnavailableDates.includes(selectedDate)
        ) {
          // Move to next day in Winnipeg timezone
          nextAvailableDate = nextAvailableDate.add(1, "day");

        } else {
          // Date is valid (not unavailable or closed)
          foundNextAvailableDate = true;
        }
      } while (!foundNextAvailableDate);

      // Return the result as a Day.js object in Winnipeg time
      return nextAvailableDate;
    },
  },
};
